<template>
  <div v-if="isAdmin">
    <div>
      <BaseSelect
        id="'select-rc-pause-reason'"
        :placeholder="$t('rc_pause_flow_menu_prompt')"
        required
        groupedOptions
        :options="reasons"
        display-text-key="label"
        :label="$t('rc_pause_flow_pause_question')"
        @onChange="e => selectReason(e)"
        labelRequiresTranslation
        :value="selectedReason"
      />
    </div>
    <div v-if="selectedReasonObject?.id === 11" class="tw:mt-4">
      <p class="tw:font-bold tw:mb-1" v-html="$t('reason_textbox')" />
      <textarea
        class="tw:outline-hidden tw:w-full tw:border tw:border-gray-500 tw:rounded-md tw:p-2 tw:max-h-[150px]"
        :placeholder="$t('rc_pause_flow_other_text_prompt')"
        @input="updateOtherExplanation($event.target.value)"
        :ref="otherExplanation"
        style="height: 56px"
      />
    </div>
    <div class="required-info tw:text-xs tw:text-gray-700 tw:mt-4" v-html="$t('required_information')" />
  </div>
  <div v-else>
    <p v-html="$t('rc_pause_admin_info')" />
  </div>
</template>
<script setup>
import BaseSelect from '@/components/BaseSelect.vue'

defineProps({
  isAdmin: Boolean,
  reasons: Array,
  selectedReason: [String, null],
  selectedReasonObject: [Object, null],
  otherExplanation: String,
})

const emit = defineEmits(['selectReason', 'updateOtherExplanation'])
const selectReason = reason => emit('selectReason', reason)
const updateOtherExplanation = value => emit('updateOtherExplanation', value)
</script>
